import { FormattedMessage } from 'react-intl'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {BundlesListFilter} from './BundlesListFilter'

const BundlesListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddBundleModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-bundle-table-toolbar='base'>
      <BundlesListFilter />

      {/* begin::Export */}
      <button type='button' className='btn btn-light-primary me-3'>
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        <FormattedMessage id='TABLE.GENERAL.EXPORT' />      </button>
      {/* end::Export */}

      {/* begin::Add bundle */}
      <button type='button' className='btn btn-primary' onClick={openAddBundleModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        <FormattedMessage id='BUNDLE.TABLE.CREATEBUNDLE' />
      </button>
      {/* end::Add bundle */}
    </div>
  )
}

export {BundlesListToolbar}
